export { default } from "ember-stereo/helpers/stereo-volume-is-adjustable";
